export const UNSCALED_DROPZONE_HEIGHT = 184;

export const AUTOMATION_IDS = {
  DROPZONE: 'sections-dropzone',
};
